import React, { useContext } from 'react';
import { CircularProgress, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import FeedContext from '../../../../context/FeedContext';
import ExternalCoachContext from '../../../../context/ExternalCoachContext';
import useUserDoc from '../../../../hooks/useUserDoc';

import ActivityHeader from '../ActivityHeader';
import ActivityContent from '../ActivityContent';
import ActivityAction from '../ActivityAction';
import ActivityStatus from '../ActivityStatus';

import {
  FeedActivityContainer,
  StyledLoaderContainer,
} from './styles';

const FeedActivity = ({ activity, onActivityActionClick }) => {
  const { activityInProgress } = useContext(FeedContext);
  // The feed is inherently coach-scoped: pin the viewed coach so the client's
  // per-coach state (postPaymentFormSubmittedAt, contract product) can't
  // resolve to another of the client's coaches.
  const { coachId } = useContext(ExternalCoachContext);
  const { userDoc: clientUserDoc } = useUserDoc(activity.user, { viewAsCoachId: coachId });

  if (activityInProgress.includes(activity.id)) {
    return <StyledLoaderContainer><CircularProgress color="inherit" /></StyledLoaderContainer>;
  }

  return (
    <FeedActivityContainer>
      <ActivityHeader activity={activity} clientUserDoc={clientUserDoc} />
      <ActivityStatus activity={activity} />
      <ActivityContent activity={activity} clientUserDoc={clientUserDoc} />
      <Divider />
      <ActivityAction
        activity={activity}
        clientUserDoc={clientUserDoc}
        onActivityActionClick={onActivityActionClick}
      />
    </FeedActivityContainer>
  );
};

FeedActivity.propTypes = {
  activity: PropTypes.object,
  onActivityActionClick: PropTypes.func.isRequired,
};

FeedActivity.defaultProps = {
  activity: {},
};

export default compose(
  observer,
)(FeedActivity);
